import { React } from 'react';

const MultiButtons = ({ children }) => {
    return (
        <div className="menu-container">
            <button className="menu-button">⋮</button>
            <div className="dropdown-menu">
                {children}
            </div>
        </div>
    );
};

export default MultiButtons;